/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlFieldAttributes {
    getFixupPrototypeFunction() { return ControlFieldAttributes.fixupPrototype; }

    static newInstance(model: Partial<ControlFieldAttributes>): ControlFieldAttributes {
        let obj = Object.assign(new ControlFieldAttributes(), model);
        ControlFieldAttributes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlFieldAttributes>): ControlFieldAttributes {
        if (!model) return null;
        return ControlFieldAttributes.newInstance(<ControlFieldAttributes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlFieldAttributes) {
        if (!obj) return;

        models.ControlFieldAttributes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlFieldAttributes): boolean {
        Object.setPrototypeOf(obj, ControlFieldAttributes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Whether this field is mandatory when creating a control
     */
    mandatory: boolean;

    /**
     * List of allowed values for dropdowns
     */
    allowed_values: Array<string>;

    /**
     * Human-readable label shown in the UI
     */
    label: string;

    /**
     * Name of the abstracted control
     */
    abstracted_name: string;

}
